import { observer } from "mobx-react";
import { OFTableController } from "../OFTableController";
import { AutoSizer } from "react-virtualized";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import StaticHeader from "./StaticHeader";
import StaticRows from "./StaticRows";
import { useEffect } from "react";

const OFVList = observer(({ ofTableController }: { ofTableController: OFTableController }) => {
  //console.log("RENDER OFVList");

  useEffect(() => {
    //console.log("OFVList useEffect------------------------------------");
    const { innerWidth, innerHeight } = ofTableController;
    ofTableController.setLastColWidth(innerWidth, innerHeight);
  }, [ofTableController, ofTableController.innerWidth, ofTableController.innerHeight]);

  return (
    <div className={ofTableController.showFilters ? "VTable" : "VTable noFilters"}>
      <AutoSizer
        onResize={({ width, height }) => {
          ofTableController.setLastColWidth(width, height);
        }}
      >
        {({ height, width }) => {
          return (
            <div className="OFVirtualised">
              <div className="relative">
                <OverlayScrollbarsComponent
                  style={{ overflow: "auto", height: height, position: "absolute", width: width, zIndex: 9 }}
                  className="test"
                  options={{
                    scrollbars: { autoHideDelay: 300, autoHide: "leave" },
                  }}
                  events={{
                    scroll: ofTableController.handleScrolling,
                    updated: () => ofTableController.scrollToRow(),
                  }}
                  ref={(ref: any) => {
                    if (!ofTableController.scrollListRef && ref) {
                      ofTableController.setScrollListRef(ref.osInstance());
                    }
                  }}
                >
                  <div
                    className="inner"
                    style={{
                      position: "relative",
                      height: `${ofTableController.innerHeight}px`,
                      width: `${ofTableController.innerWidth}px`,
                    }}
                  >
                    <StaticHeader ofTableController={ofTableController} />
                    <StaticRows height={height} ofTableController={ofTableController} />
                  </div>
                </OverlayScrollbarsComponent>
              </div>
            </div>
          );
        }}
      </AutoSizer>
    </div>
  );
});

export default OFVList;
